import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { schema, defaultValues } from "./schema";
import { handleMessageError, handleMessageSuccess, handleMessageWarning } from "../../../../components/toast";
import { getReturnUpdated } from "../../../../util/libObject";
import { format, parseISO } from "date-fns";

export const IndexHook = ({
	isOpenModalRegister,
	ident,
	idTable,
	selectedData,
	setSelectData,
	fetchID,
	reloadData,
	insert,
}) => {
	const {
		register,
		handleSubmit,
		setValue,
		reset,
		control,
		formState: { errors, isSubmitting },
	} = useForm({
		mode: "onSubmit",
		resolver: zodResolver(schema),
		defaultValues: defaultValues,
	});

	const [isInsert, setIsInsert] = useState(false);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (isOpenModalRegister) {
			const id =
				typeof selectedData[idTable] === "number" && !isNaN(selectedData[idTable])
					? selectedData[idTable]
					: 0;

			if (id > 0) {
				fetchData(id);
			} else {
				reset(defaultValues);
			}

			setIsInsert(id === 0);
		} else {
			if (setSelectData) setSelectData({});
			reset(defaultValues);
		}
	}, [isOpenModalRegister, selectedData]);

	const fetchData = async (id) => {
		try {
			setLoading(true);
			const response = await fetchID(id);

			if (response.data && typeof response.data === "object") {
				const data = Array.isArray(response.data) ? response.data[0] : response.data;
				
				const formatDateForInput = (dateStr) => {
					if (!dateStr) return "";
					try {
						// parseISO + format garante que pegamos apenas o necessário para o input local
						const date = parseISO(dateStr);
						return format(date, "yyyy-MM-dd'T'HH:mm");
					} catch (e) {
						return dateStr;
					}
				};

				Object.keys(data).forEach((field) => {
					const fieldLower = field.toLowerCase();
					if (fieldLower === "data_inicio" || fieldLower === "data_fim") {
						setValue(fieldLower, formatDateForInput(data[field]));
					} else {
						setValue(fieldLower, data[field]);
					}
				});
			}
		} catch (error) {
			handleMessageError(error.message || error);
			handleCloseModalRegister();
		} finally {
			setLoading(false);
		}
	};

	const handleOnSubmit = async (data) => {
		try {
			const submitData = {
				...data,
				// Garante o formato ISO completo para o Delphi
				data_inicio: data.data_inicio.length === 16 ? data.data_inicio + ":00" : data.data_inicio,
				data_fim: data.data_fim.length === 16 ? data.data_fim + ":00" : data.data_fim,
			};

			const response = await insert(submitData);

			const returned = getReturnUpdated(response);
			const currentId = returned?.id_pausa_programada ?? 0;
			const oldID = data.id_pausa_programada;

			await reloadData(oldID, currentId);

			handleMessageSuccess("Pausa programada salva com sucesso.");
			reset(defaultValues);
			handleCloseModalRegister();
		} catch (error) {
			handleMessageWarning("Não foi possível salvar: " + (error.message || error));
		}
	};

	const handleCloseModalRegister = () => {
		const event = new CustomEvent(`${ident}`);
		window.dispatchEvent(event);
	};

	return {
		register,
		control,
		errors,
		isSubmitting,
		setValue,
		handleSubmit,
		handleOnSubmit,
		handleCloseModalRegister,
		isInsert,
		loading,
	};
};
